module.exports = __webpack_public_path__ + "static/media/sujay-dp.fcc86da5.jpg";